import { Component, OnInit, Input, ChangeDetectorRef, Output, AfterViewInit, Inject } from '@angular/core';
import { UntypedFormBuilder, Validators, FormArray, UntypedFormGroup } from '@angular/forms';
import * as _ from 'lodash';
import * as moment from 'moment';
import { ECalendarValue, IDatePickerConfig, } from 'ng2-date-picker';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ToastrService } from 'ngx-toastr';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SERVICE_BOOKING_API, ServiceBookingApi } from '@app/_services/service-booking-api';
import { AvailableSlot } from '@interfaces/professional-booking';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgIf, NgFor, NgClass, DatePipe } from '@angular/common';

@Component({
    selector: 'app-timeslot-view',
    templateUrl: './timeslot-view.component.html',
    styleUrls: ['./timeslot-view.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        NgFor,
        NgClass,
        ExtendedModule,
        DatePipe,
        TranslateModule,
    ],
})
export class TimeslotViewComponent implements OnInit, AfterViewInit {
    constructor(
        public fb: UntypedFormBuilder,
        @Inject(SERVICE_BOOKING_API) private bookingApi: ServiceBookingApi,
        private toastr: ToastrService,
        private translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        if (this.timeslots?.length) this.form.get('date')?.setValue(new Date());
    }

    @Input() timeslots;

    selectedYearMonth;

    selectedDay;

    inting = true;

    //selectedTimeslots = [];

    ngAfterViewInit(): void {

        this.form.get('date')?.valueChanges.subscribe((value) => {
            //set upon getting the first set of timeslots
            if (value && value != '')
                //this.selectYearMonth(value);
                this.selectDay(value);
            else {
                this.timeslots = [];
                if (!this.form.get('timeslots'))
                    this.form.addControl('timeslots', this.fb.control([]))
            }
            if (!this.form.get('timeslots')?.value) this.form.get('timeslots')?.setValue([]);
        });
        if (!this.form.get('timeslots'))
            this.form.addControl('timeslots', this.fb.control([]))
    }

    @Input() form: UntypedFormGroup;
    @Input() product;
    selectedTimes = {};

    selectDay(selected) {
        if (this.product.dateType != 'single_date' || this.product.timeType != "time_slots") return;
        this.selectedDay = selected;
        this.timeslots = null;
        this.form.get('timeslots').setValue([]);
        let toDate = new Date(selected);
        this.selectedTimes = {};
        this.bookingApi.getAvailableTimes(this.product._id, toDate.toLocaleDateString('en-CA')).subscribe((response) => {
            this.timeslots = response.code == 200 && response.data ? response.data : [];
            this.timeslots.forEach(timeslot => {
                timeslot.available = timeslot.amount;
                timeslot.amount = timeslot.minAmount || 1;
                timeslot.control = this.fb.control(timeslot.minAmount || 1)
            });
        }, () => {
            this.toastr.error(this.translate.instant('error_loading_timeslots'));
        });
    }

    addRemoveTimeslot(timeIndex) {
        const selected = this.timeslots[timeIndex];
        let index = this.form.get('timeslots')?.value?.findIndex((timeslot) => {
            return selected.range?.start == timeslot.range?.start && selected.range?.end == timeslot.range?.end;
        });

        if (index > -1) {
            let timeslotsValue: any[] = this.form.get('timeslots')?.value;
            timeslotsValue.splice(index, 1);
            this.form.get('timeslots')?.setValue(timeslotsValue);
            delete this.selectedTimes[timeIndex];
        } else {
            // One slot per booking where the backend allows only one (professional services)
            let timeslotsValue: AvailableSlot[] = this.bookingApi.singleSlot ? [] : this.form.get('timeslots')?.value;
            if (this.bookingApi.singleSlot) this.selectedTimes = {};
            timeslotsValue.push(selected)
            this.form.get('timeslots')?.setValue(timeslotsValue);
            this.selectedTimes[timeIndex] = true;
        }

        /*  if(index != -1){
         this.form.get('timeslots')?.value?.splice(index, 1);
         }else{
             this.form.get('timeslots')?.value?.push(selected);
         } */
    }

    isSelected(timeslot) {
        let index = this.form.get('timeslots')?.value?.findIndex((item) => {
            return timeslot.range?.start == item.range?.start && timeslot.range?.end == item.range?.end;
        });
        return index > -1 ? true : false;
    }


    removeTimeslot(selected) {
        this.form.get('timeslots')?.value?.splice(this.form.get('timeslots')?.value?.indexOf(selected), 1);
    }

    setAmount(timeslot, amount) {
        timeslot.amount = amount;
        timeslot.control.setValue(timeslot.amount);
    }

    onTouched = () => { };
}
